<!-- home -->
<template>
  <div class="index-container policy-detail" @click="hideSearch">
    <div v-if="channelsFlag == '0'">
      <div class="bg-box" />
      <!-- <div class="logo"></div> -->
      <div class="home-title">
        <div class="title-1">政策通</div>
        <div class="title-2">通达所有政策</div>
      </div>
      <!--<div class="vip-box">-->
        <!--<img src="@/assets/images/tag_vip@2x.png" alt="" v-if="isVip">-->
        <!--<img @click="toVip"  src="@/assets/images/tag_vip_1@2x.png" alt="" v-else>-->
      <!--</div>-->
      <div class="header">
      <div class="logo-box">
        <img class="img-logo" src="@/assets/images/logo_3@2x.png" alt="">
        <img class="img-title" src="@/assets/images/title_1@2x.svg" alt="">
      </div>
    </div>
    </div>
    <div v-if="channelsFlag == '1'">
      <div class="bg-box_channes" :style="{backgroundImage: `url(${channelsInfo.bk_img_path})`, backgroundSize:'contain'}"></div>
      <!--<div class="vip-box">-->
        <!--<img src="@/assets/images/tag_vip@2x.png" alt="" v-if="isVip">-->
        <!--<img @click="toVip"  src="@/assets/images/tag_vip_1@2x.png" alt="" v-else>-->
      <!--</div>-->
      <div class="header header-channes">
        <div class="logo-box">
          <img class="img-logo" :src="channelsInfo.logo_img_path" alt="">
          <img class="img-title" :src="channelsInfo.words_img_path" alt="">
        </div>
      </div>
    </div>
    <van-popup v-model:show="show1" round position="bottom" :style="{ height: '40%' }" >
        <div class="boxs">
                <p class='title'>请选择发文部门</p>
                <div class="field-ul">
                    <div  class="flex-tag-select-container">
                        <div v-for="(item, i) in fieldList" :key="item.dispatch_name" class="flex-tag-select-item"
                            :class="{ 'selected': item.checked }" @click="() => toggleItem(item,item.id)">
                            {{ item.dispatch_name }}
                        </div>
                    </div>
                </div>
                <van-button  @click="roundbtn2" class="roundbtn" round type="primary">确定</van-button>
        </div>
    </van-popup>
    <van-popup v-model:show="show2" round position="bottom" :style="{ height: '30%' }" >
        <div class="boxs">
                <p class='title'>请选择行政级别</p>
                <div class="field-ul">
                    <div  class="flex-tag-select-container">
                        <div v-for="(item, i) in public" :key="item.level" class="flex-tag-select-item"
                            :class="{ 'selected': item.checked }" @click="() => toggleItem2(item,item.level)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <van-button  @click="roundbtn1" class="roundbtn" round type="primary">确定</van-button>
        </div>
    </van-popup>
    <van-popup v-model:show="show2" round position="bottom" :style="{ height: '30%' }" ></van-popup>
    <!-- <coupon-ad></coupon-ad>  -->
    <div class="warpper">
     <match  :searchStr="searchStr" :list="noticeList" :isVip="isVip" :certificationFlag="certificationFlag" :total="totalMatch" :loadingFav="loadingFav" @doFav="doFav"></match> 
     <div  @click="backTop"  class="backTop" v-show="showgo">
        <img src="../../assets/icons/回顶部.svg" alt="">
    </div>
    </div>
  </div>
  <van-popup v-model:show="showPicker" position="bottom">
    <van-picker :columns="options" @confirm="onConfirm" :columns-field-names="columnsFieldNames"
      @cancel="showPicker = false" />
  </van-popup>


  <van-popup v-model:show="showCouponPopup" @close="closeCouponPopup" style="width:90%;background: transparent;">
    <div class="coupon-box coupon-popup-box">
      <img src="@/assets/images/coupon/bg_popup_1@2x.png">
      <div class="coupon-btn-b">
      <van-button class="coupon-btn" type="primary" @click="goCoupon">去领取</van-button>
      </div> 
    </div>
  </van-popup>

</template>

<script>

import { Dialog, Notify } from "vant"
import { search, add, del } from "@/api"
import moment from "moment"
import { info, cache, ws } from "@/api"
import Select from '@/components/Select.vue'
import backTop from '@/components/BackTop.vue'
import SearchDetail from '@/components/SearchDetail.vue'
import { clickUrl, debounce, desensitization, checkResearch } from "@/utils"
import { getCompanyLists, getTopPolicy, getLatestRecord, getDispatchv3,getUserInfoByUserId, queryUserById,getUserInfoZqcli, addFavorite, cancelFavorite,dispatchDepartmentGetAllv3,channelsUser } from '@/api/home'
import { getUserInfo, setUserInfo, setToken, setUserId, getSearchHistory, setSearchHistory, setQuestion } from '@/utils/storage'
import CouponAd from '../../components/CouponAd.vue'
import { ZqcUrl, ZqcUrlCompanyone } from '@/config'
import Match from "./component/match.vue"
import store from "@/store";
import { mapState } from "vuex"

export default {
  name: "Home",
  data() {

    return {
       showgo:false,
      show1:false,
      show2:false,
      show3:false,
      formSearch: {
        searchStr: "",
      },
      searchStr:'',
      searchList: [],
      showPicker: false,
      noticeList: [],
      swipeList: [],
      isFocus: false,
      isVip: false,
      isSearch: false,
      stoageHistory: [],
      currentSearchStr: '',
      showCouponPopup: false,
      couponInfo: {},
      loadingFav: false,
      certificationFlag: 0,
      totalMatch: 0,
      fieldList:[],
       tabs: [
        { title: "政策口径", id: '1' },
        { title: "行政级别", id: '2' },
      ],
      public1:[
        { id:'1', name: '国',value: '',checked: false },
          { id:'2', name: '省',value: '',checked: false },
          { id:'3', name: '市',value: '',checked: false },
          { id:'4', name: '区县',value: '',checked: false },
      ],
      channelsFlag: '',
      channelsInfo: {},
      channels_id: ''
    }
  },
  components: { Select, SearchDetail,CouponAd,Match },
  computed: {
    ...mapState({
      KEEP_ALIVE_COMS: state=>state.routerCache.KEEP_ALIVE_COMS || []
    }),
  },
  watch: {
    formSearch: {//深度监听，可监听到对象、数组的变化
      handler() {
        this.formDebounce(this);
      },
      deep: true //true 深度监听
    }
  },
  mounted() {
    this.stoageHistory = getSearchHistory() || []
    this.userId = this.$route.query.userId
    if (this.$route.query.userInfo) {
      this.userInfo = JSON.parse(this.$route.query.userInfo)
      setToken(this.userInfo.token)
      setUserId(this.userInfo.userId)
      setUserInfo(this.userInfo)
    }
    window.addEventListener('scroll', this.handleScroll)
    
  },
  activated() {
    if (sessionStorage.getItem('reload')) {
      sessionStorage.removeItem('reload')
      location.reload()
      return 
    }
    this.init()
  },
  methods: {
    moment,
    init() {
      this.channels_id = this.getUrlValue('channels_id')
      if (this.channels_id) {
        this.getChannelsInfo()
      } else {
        this.channelsFlag = 0
      }
      this.getCompany()
      this.getUserInfoZqc()
    },
    async getChannelsInfo() {
      try {
        let res = await channelsUser({ channels_id: this.channels_id })
        this.channelsFlag = res.result != null ? 1 : 0
        this.channelsInfo = res.result
      } catch {
        
      }
    },
    getUrlValue(kValue) {
      var url = window.location.href;  //当前页面的地址
      var reg = /([^?&=]+)=([^?&=]+)/g, obj = {}, str = url;
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      })
      for (var keyName in obj) {
        if (keyName == kValue) {
          let val = obj[keyName]
          if (val.indexOf("#") > 0) {
            val = val.substring(0, val.indexOf("#"))
          }
          return val;
        }
      }
    },
    //   toVip(){
    //   clickUrl('/vip')
    // },
      handleScroll (){
        if (window.scrollY > 400 ) {
      this.showgo = true
        } else {
          this.showgo = false
        }
      },
     backTop() {
      scrollTo(0, 0);
      this.showgo=false
    },
    toggleItem(item) {
            item.checked = !item.checked
        },
        roundbtn2(){
          this.show1=false
        },
     changeTabs(val) {
      this.getbumen()
      console.log(val.name);
      if(val.name==1){
        this.show1 = !this.show1
      }else if(val.name==2){
this.show2 = !this.show2
      }
      // this.activeTabs = val.name
      // this.reset()
      // this.getdispatchDepartment()
      // this.getData()
    },
    async getbumen (){
      let res = await getDispatchv3({type:2})
      console.log(res);
      this.fieldList = res.result
    },
    async getCompany() {
      try {
        let res = await queryUserById()
        this.userInfo = res.result || {}
        let e_time = res.result.expiration_time ? res.result.expiration_time.replace(/-/g, '/') : null
        let expirationTime = new Date(e_time).getTime()
        let time = new Date().getTime()
        this.isVip = time < expirationTime ? true : false
        this.certificationFlag = res.result.certification_flag
        if(!res.result.authentication_flag){
          this.checkCoupon()
        }
        // this.getTopPolicy()
      } catch {

      }
    },
    formDebounce: debounce(function () {
      this.search()
    }, 1000),
    handleInput() {
      this.isFocus = true
    },
    hideSearch() {
      this.isFocus = false
    },
    async search() {
      this.isSearch = true
      this.currentSearchStr = this.formSearch.searchStr
      let res = await getCompanyLists({ keywords: this.formSearch.searchStr })
      this.searchList = res.result || []
      this.isSearch = false
    },
    goSearch() {
      this.isFocus = false
      let searchStr = {}
      if (this.formSearch.searchStr) {
        searchStr.name = this.formSearch.searchStr
        this.setHistory(this.formSearch.searchStr)
      }

      clickUrl('/search/1', { search: JSON.stringify(searchStr), type: 2 })
    },
    toMatchDetail(arg) {
      console.log(arg)
      this.setHistory(arg.name)
      clickUrl('/search/1', { search: JSON.stringify(arg), type: 1 })
      this.isFocus = false
    },
    setHistory(val) {
      if (!val) {
        return false
      }
      let history = getSearchHistory()
      if (!history.length) {
        this.stoageHistory.unshift(val)
        setSearchHistory(this.stoageHistory)
        return false
      }
      
      if (this.stoageHistory.indexOf(val) != -1) {
        this.stoageHistory.splice(this.stoageHistory.indexOf(val), 1)
        this.stoageHistory.unshift(val)
      } else {
        this.stoageHistory.unshift(val)
      }

      if (this.stoageHistory.length > 6) {
        this.stoageHistory.pop()
      }
      setSearchHistory(this.stoageHistory)

    },
    updateSearchStr(arg) {
      // this.formSearch.searchStr = arg
      let searchStr = {
        name: arg
      }
      clickUrl('/search/1', { search: JSON.stringify(searchStr), type: 2 })
    },
    goNoticeSearch() {
      this.isFocus = false
      clickUrl('/notice_search')
    },
    async getTopPolicy() {
      let size = this.isVip ? 5 : 2

       try {
        let res = await getTopPolicy({ 'pageSize': size })

        this.noticeList = res.result.data.map(item => {
          let arr = []
          arr.push(item.dispatch_name)
          return {
            ...item,
            release_date: item.release_time ? moment(item.release_time).format('YYYY-MM-DD') : '',
            policyTopic: arr
          }
        }) || []
        this.totalMatch = res.result.total || 0
      } catch {
        this.totalMatch = 0
      }
    },
    async getLatestRecord() {
      let res = await getLatestRecord({ pageSize: 5 })
      this.swipeList = res.result.data.map(item => {
        return {
          ...item,
          nameView: desensitization(item.search_company_name, 4, 2)
        }
      }) || []
    },
    goDetail(item) {
      clickUrl('/notify/detail', { id: item.notify_id,articleId:item.id, policyId: item.id, title: '通知公告详情', btnType: '0' })
    },
    goNoticMore() {
      clickUrl('/policy_query/index', { type: 'notify' })
    },
    /** 科服券 **/
    checkCoupon() {
      return false
//      if(sessionStorage.getItem('couponPopupFlag')){
//        return false
//      }
//      this.showCouponPopup = true
      // if(!this.isVip){
      //   // if(!sessionStorage.getItem('couponPopupFlag') && !this.userInfo.coupon){
      //     this.couponInfo = {
      //         title: '尊敬的VIP客户',
      //         content: '您有一张1000元科服券，待领取\n 认证企业信息即可领取',
      //         btnTxt: '去领取'
      //       }
      //     this.showCouponPopup = true
      //   // }
      //   return false
      // }
     
      // // if(!localStorage.getItem('couponVipPopupFlag')){
      //   this.couponInfo = {
      //     title: '尊敬的VIP客户',
      //     content: '您有 11 张面值1000元科服券，已入账\n 请到“我的-我的卡券”中查看',
      //     btnTxt: '去看看'
      //   }
      //   this.showCouponPopup = true
      // // }
    },
    closeCouponPopup(){
      this.showCouponPopup = false
      sessionStorage.setItem('couponPopupFlag',1)
      // if(this.isVip){
      //   localStorage.setItem('couponVipPopupFlag',1)
      // }else{
      //   sessionStorage.setItem('couponPopupFlag',1)
      // }
    },
    goCoupon(){
      sessionStorage.setItem('couponPopupFlag',1)
      if(this.isVip){
        clickUrl('/coupon')
      }else{
       clickUrl('/coupon/use_detail')
      }
    },

     /** 科服券 **/
    async getUserInfoZqc(){
      var that = this
      try {
        let res = await getUserInfoZqcli()
        that.info = res.result || {}
        if (!that.info.org_id || that.info.org_id == null) {
          return
        }
        sessionStorage.setItem('urlZct', location.href)
        if (that.info.status == 0) {
          window.location.href = window.location.origin + ZqcUrlCompanyone
          return;
        }
        if(that.info.questions && that.info.questions.length){
          checkResearch(that.info.questions)
        }
      }catch(res){
        if(res.status == 6){
          sessionStorage.setItem('urlZct', location.href)
          window.location.href = window.location.origin + ZqcUrlCompanyone
        }
      }
    },
    async doFav(arg) {
      var that = this
      if (that.loadingFav) {
        return false
      }
      that.loadingFav = true
      const request = arg.type ? addFavorite : cancelFavorite
      let res = await request({ 'notify_id': arg.id })
      this.$toast.success({ message: arg.type ? '收藏成功' : '取消收藏成功', duration: 2000 })
      setTimeout(() => {
        // that.getTopPolicy()
        that.loadingFav = false
      }, 2000)
    },
    goSearchV2() {
      this.searchStr = this.formSearch.searchStr
      console.log(this.searchStr);
      // clickUrl('/enterprise_match')
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.KEEP_ALIVE_COMS.includes('Home')) {
      store.commit("ADD_KEEP_ALIVE_COM", "Home")
    }
    next();
  },
}


</script>
<style lang="scss" scoped>
.index-container {
  position: relative;
  /* overflow-x: hidden; */
  background-color: #fff;
  .home-title {
    position: relative;
    z-index: 10;
    margin-top: 60px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    font-family: 'FZZhengHeiS-DB-GB-Regular, FZZhengHeiS-DB-GB';

    .title-1 {
      letter-spacing: 15px;
    }

    .title-2 {
      font-size: 31px;
    }
  }

  .bg-box {
    width: 100%;
    height: 220px;
    // background: linear-gradient(to bottom, #1989fa, rgba(255, 255, 255, 0));
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 0;
    background: url('../../assets/images/bg_home@2x.png') no-repeat center center;
    background-size: cover;
  }

  .header {
    margin: 35px auto 20px;
    // background: linear-gradient(219deg, #FFFFFF 0%, #1293ED 100%);
    background: linear-gradient(180deg, #FFF4E0 0%, #FBCB89 100%);
    border-radius: 10px;
    padding: 60px 12px 10px 12px;
    position: relative;
    height: 35px;
    &.header-channes{
      margin-top: 167px;
      .logo-box {
        .img-logo {
          width: 94px;
          bottom: -30px;
        }
      }
    }
    .logo-box {
      text-align: center;
      margin-bottom: 20px;
      color: #0F96E9;
      font-size: 16px;
      letter-spacing: 5px;
      font-family: 'FZZhengHeiS-DB-GB-Regular, FZZhengHeiS-DB-GB';
      position: absolute;
      top: 20px;
      display: flex;

      .img-logo {
        position: absolute;
        bottom: -20px;
        left: 0px;
        width: 84px;
        background-size: contain;
        margin: 0 10px;
        vertical-align: middle;
      }

      .img-title{
        flex: 1;
        margin-left: 105px;
        vertical-align: middle;
        height: 20px;
        background-size: contain;
      }

      .txt {
        flex: 1;
        margin-left: 95px;
      }
    }

  }

  .vip-box {
    width: 91px;
    height: 87px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 20;

    img {
      width: 100%;
      background-size: contain;
    }
  }

  .notice-box {
    height: 27px;
    background: rgba(254, 237, 211, 0.63);
    border-radius: 8px;
    opacity: 1;
    border: 1px solid #FFF;
    margin: 20px 0;
    color: #000;
    font-size: 12px;
  }

  .notice-swipe {
    height: 40px;
    line-height: 43px;
  }

  .match-container-search {
    margin-bottom: 20px;
    height: 42px;
    // margin: 0 12px;
    border: 1px solid #fff;
    border-radius: 26px;
    display: flex;
    position: relative;
    display: flex;
    flex-direction: row;
    background: #fef0db;
    box-shadow: 0px 4px 4px 1px rgba(245, 192, 118, 1);

    input {
      flex: 1;
      height: 36px;
      border-top-left-radius: 26px;
      border-bottom-left-radius: 26px;
      border: 0;
      // border-right: 2px solid #ededed;
      border-right: 2px solid #fff;
      box-sizing: border-box;
      padding: 0 8px 0 30px;
      font-size: 12px;
      // background: #d7f0ff;
      background: #fef0db;
      margin: 4px 0;

      &::placeholder {
        color: #808080;
      }
    }

    .btn {
      width: 60px;
      height: 36px;
      background: #FE8119;
      border-radius: 26px;
      border: 1px solid rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto 3px auto 7px;

      img {
        width: 27px;
        background-size: contain;
      }
    }

    .detail {
      width: 100%;
      position: absolute;
      top: 46px;
      left: 0px;
      z-index: 999;
    }
  }

  .notice-list-box {
    padding: 8px 15px;

    .title {
      justify-content: space-between;

      .txt {
        border-bottom: 3px transparent solid;
	      border-image: linear-gradient(270deg, #1F6BE8 0%, rgba(20, 141, 237, 0.25) 100%) 1 10;
      }

      .btn-box {
        margin: 0;
        text-align: right;
      }
    }
  }

  .content-box {
    // background: linear-gradient(180deg, #DFF2FF 0%, #E5F1F9 100%);
    // border-radius: 8px;
    border-bottom: 1px solid #e3e8eb;
    font-size: 12px;
    margin: 10px 0;
    padding: 10px;
    font-weight: 500;
    

    .content-li {
      justify-content: space-between;
    }

    .content-date {
      width: 160px;
      text-align: right;
      white-space: nowrap;
      color: rgba(0,0,0,.5);
    }
  }

}

.txt-one {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(0,0,0,.7);
}

.more-btn {
  font-size: 12px;
  color: #000;
  font-weight: 500;
  margin-top: 3px;
}

.icon-right {
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  margin-left: 3px;

  &.icon-right-1 {
    background: url('../../assets/images/icon_1@2x.png') no-repeat center center;
    background-size: contain;
  }

  &.icon-right-2 {
    background: url('../../assets/images/icon_2@2x.png') no-repeat center center;
    background-size: contain;
  }
}

.logo {
  position: absolute;
  top: 7px;
  left: 17px;
  z-index: 30;
  width: 62px;
  height: 22px;
  /* background: url('../../assets/images/logo_2@2x.png') no-repeat center center; */
  background-size: contain;
}

::v-deep(.van-grid-item__icon-wrapper) {
  margin-bottom: 5px;
}

.coupon-box {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    position: relative;
  
    img {
      width: 100%;
      height: 100%;
      background-size: contain;
    }
  }

.coupon-popup-box{
  .coupon-btn-b{
    width: 100%;
    height: 1.3rem;
    position: absolute;
    bottom: 16%;
    left: 0;
    text-align: center;
  }
  .coupon-btn{
    width: 58%;
    height: 1.3rem !important;
    line-height: 1.3rem;
    margin-left: 0.53rem;
    background: linear-gradient(180deg, #F8E9CE 0%, #F1CE99 100%);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.25);
    border-radius: 0.61rem;
    border: 0;
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
}
</style>
<style lang="scss" scoped>
.van-icon-arrow:before {
  color: #1391E9;
}
.tabs-box {
  background-color:#FBCB89  ;
  .van-tabs__nav1 {
      background-color:#FBCB89  ;
  }
}
.fav {
  display: flex;
  justify-content: space-around;
   color: #1989FA;
   background-color: #fff;
   height: 30px;
   line-height: 30px;
}
 .field-ul {
      margin: 0 20px;
      display: flex;
      flex-wrap: wrap;
  }
  .flex-tag-select-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        box-sizing: border-box;
        z-index: 10;
        overflow: auto;
    }
    .title {
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 16px;
      text-align: center;
      background-color: #F2F2F2;
      margin-top: 0px;
      height: 30px;
      line-height: 30px;
    }
     .flex-tag-select-item {
      display: flex;
        justify-content: center;
        align-items: center;
        color: #252525;
        min-height:30px;
        border: 1px solid #fff;
        box-sizing: border-box;
        background: #CDEDFC;
    }
    .flex-tag-select-item.selected {
        border: 1px solid #1b53b9;
        color: #1b53b9;
        background: #ebf3fa;
    }
    .roundbtn{
      background-color: #02A7F0;
      color: #fff;
      width: 100px !important;
      margin-left: 35% !important;
      margin-top: 20px !important;
    }
    .warpper {
      background-color: #fff;
    }
    .flex-item{
      font-size:15px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      letter-spacing: 2px;
    }
    .backTop {
 width: 49px;
height: 49px;
background: rgba(25, 196, 250, 0.8);
opacity: 0.8;
  position: fixed;
  bottom: 70px;
  right: 20px;
  background-color: #FFF;
  border-radius: 50%;
  z-index: 999;
  img {
    width: 49px;
    height: 49px;
  }
}

.bg-box_channes{
  width: 100%;
    height: 220px;
    // background: linear-gradient(to bottom, #1989fa, rgba(255, 255, 255, 0));
    position: absolute;
    left: 0;
    right: 0;
    top: -1px;
    z-index: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}

</style>
